<template>
  <div class="hisVideo">

    <div class="videoHeader">
      <div style="">
        <el-row>
          <el-col :span="24" style="display:flex">
            <div style="height:30px;padding: 10px 5px 0px 0px;flex:1;" uclass="jstifyLeft">
              <el-button :checked="seletedAll" size="mini" type="primary" style="margin-left:10px" @click="playRealVideo">实时视频</el-button>
            </div>
            <div style="height:30px;padding: 10px 10px 0px 5px;width:100%;position: relative;" class="justifyRight">
              <i class="el-icon-search" style="position: absolute;left: 15px; z-index: 99;color: #999;"></i>
              <el-input size="mini" placeholder="车牌号" v-model="searchKey" clearable @input="truckSearchInput" :disabled="truckInfo.userType===2">
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9" style="display:flex">
            <div style="height:30px;padding: 5px 5px 0px 10px;" class="justifyLeft">
              <el-date-picker v-model="hisVideoDate" size="mini" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="15" style="display:flex">
            <div style="height:30px;padding:5px 10px 0px 5px;" class="justifyLeft">
              <el-time-picker is-range size="mini" v-model="hisVideoStartEndTime" format="HH:mm:ss" value-format="HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
              </el-time-picker>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13" style="display:flex">
            <div style="height:30px;padding:5px 10px 10px 0px;;flex:1;" uclass="jstifyLeft">
              <div style="height:auto;width:100%;display: inline-block;position:sticky ;z-index:2;background:#ffffff;padding-left:10px;width: 148px;float: left;    min-height: 30px;">
                <el-checkbox-group v-model="truckInfo.selectChs" size="mini" @change="passChange">
                  <el-checkbox size="mini" style="width: auto;float: left;height: 30px;line-height: 30px;" v-show="moreIsClick ? index + 1 : index < 4" v-for="(channel,index) in truckInfo.channels" :label="channel" :key="index">{{channel}}</el-checkbox>
                </el-checkbox-group>
              </div>
              <i class="el-icon-more" style="margin-left:5px;display: inline-block;float: left;line-height: 30px;" @click="morePassClick"></i>
            </div>
          </el-col>
          <el-col :span="11" style="display:flex">
            <div style="height:30px;padding: 5px 5px 10px 0px;flex:1;" uclass="jstifyLeft">
              <el-button :checked="seletedAll" size="mini" type="primary" style="margin-left:10px" @click="seletedAllCheck">全选</el-button>
              <!-- </div>
            <div style="height:30px;padding: 5px 10px 10px 0px;" class="justifyLeft"> -->
              <el-button size="mini" type="primary" icon="el-icon-search" @click="searcHisVideo">查询</el-button>
            </div>
          </el-col>
        </el-row>

      </div>
    </div>
    <!-- 车牌搜索面板 -->
    <div class="treeSelectContent" v-if="showContent">
      <div style="overflow-y: auto;" class="scroll-y-auto" id="truckScrollId">
        <div v-if="showContentLoading" style="padding:20px">
          <i class="el-icon-loading flexCenter" style="font-size:20px"></i> <span style="font-size:15px;color: #777777;">{{loadContent.contentrefresh}}</span>
        </div>
        <div class="truckItem" v-if="!showContentLoading" v-for="(item, index) in truckSelects" :key="index" @click="truckSearchSelect(item)">
          <div class="flexCenter" style="width: 40px;">
            <div style="box-sizing: border-box;line-height: 20px;;background: #a6a6a6;border-radius: 100px;color: #ffffff;display: flex;justify-content: center;align-items: center;font-family: 'Helvetica Neue', Helvetica, sans-serif;font-size: 12px;padding: 0px 6px;opacity: 0.7;" :style="{width:(String(index+ 1).length * 8 + 12)+'px'}">{{index+ 1}}</div>
          </div>
          <div style="display: flex;flex: 1;border: 1px solid #D2D2D2;border-radius: 5px;box-shadow: #d2d2d2 0px 0px 4px;">
            <div :class="['flexCenter', truckStateColorEnum[item.state]]" style="width: 80px;border-radius: 5px 0px 0px 5px;">
              <div style="padding: 4px 0px;">
                <div class="flexCenter" style="font-size: 13px;">{{ truckStateEnum[item.state] }}</div>
                <div class="flexCenter" :style="{height: item.stateDesc?'21px':''}">{{ item.stateDesc }}</div>
              </div>
            </div>
            <div style="flex:1;background-color: #FFFFFF;border-radius: 0px 5px 5px 0px;" class="alignCenter">
              <div>
                <div class="justifyLeft" style="width:100%;padding:1px 5px;font-size:15px">{{item.plateNo}}</div>
                <div style="width:100%;padding:1px 5px;font-size:13px;color: #AAAAAA;" v-if="item.state !== 'disable'" class="justifyLeft">
                  <i class="el-icon-time" style="margin-right:2px"></i> {{ moment(item.gpsTime).format('MM-DD HH:mm:ss')}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="(truckFilters.length > pageSize  || truckSelects.length===0) && !showContentLoading" style="padding:10px">
          <span style="font-size:15px;color: #777777;" v-if="loadstate==='noMore'">{{loadContent.contentnomore}}</span>
          <span style="font-size:15px;color: #777777;" v-if="loadstate==='loading'"><i class="el-icon-loading flexCenter" style="font-size:20px"></i>{{loadContent.contentrefresh}}</span>
          <span style="font-size:15px;color: #777777;" v-if="loadstate==='more'" @click="loadMoreClick">{{loadContent.contentdown}}</span>
        </div>
      </div>
      <div style="height:45px;display: flex;justify-content: center;align-items: center;">
        <div style="" @click="truckSearchClose">
          <i class="el-icon-close" style="font-size:30px;color:#c8c8c8;font-family: uniicons;text-decoration: none;"></i>
        </div>
      </div>
    </div>
    <!-- 视频窗口 -->
    <div class="container" :style="{height:videoHeight+'px'}">
      <div :style="{height:videoHeight+'px'}" class="videoContainer" ref="videoOutRefs" style="float:left;" v-for="(item, index) in liveMapping" :key="item.id" :index="index + 1" @click="dbFullScreen(item.id)">
        <video webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-video-player-type="h5" x5-video-orientation="h5" ref="videoRefs" class="monitorVideo" :muted="item.muted">{{ item.liveUrl }}</video>
        <div class="vehicleInfo">
          <div class="vehiclePass" v-show="item.channel">{{ '通道' + item.channel }}</div>
          <div>
            <div class="playVid videoBtn" @click="playVideo(item.id,true)" v-show="item.playeState"></div>
            <div class="pauseVid videoBtn" @click="stopVideo(item.id)" v-show="!item.playeState"></div>
            <div class="disableMute videoBtn" @click="voiceOn(item.id)" v-show="item.muteState"></div>
            <div class="enableMute videoBtn" @click="voiceOff(item.id)" v-show="!item.muteState"></div>
            <div class="showFull videoBtn" @click="fullScreen(item.id)"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hisVideolList.length>0" class="scrollpage" :style="{height:videoHisHeight+'px'}">
      <div class="channelNew" v-for="(item, index) in hisVideolList" :key="index" @click="playedHisVideo(item)">
        <div class="channelItem">
          <div class="videoChannel">{{item.logicalChn}}</div>
          <div class="videoTime">{{item.beTime}}</div>
          <!-- <div class="videoLine"></div>
          <div class="videoSize">{{item.fileSize>=1000?parseFloat((item.fileSize/1024.0).toFixed(0))+'G':(item.fileSize/1.0).toFixed(0)+'M' }}</div> -->
        </div>
      </div>
    </div>

    <!-- 底部加载中 -->
    <div v-if="hisVideolList.length===0" style="margin-top:20px;">
      <div v-if="!hisVideoLoading">
        <!-- <span style="font-size: 15px;color: #606266;" v-if="hisVideoLoading===null">请查询...</span> -->
        <span style="font-size: 15px;color: #606266;" v-if="hisVideoLoading===false">暂无数据...</span>
      </div>
      <div v-if="hisVideoLoading">
        <i class="el-icon-loading" style="font-size: 20px;vertical-align: top;"></i><span style="font-size: 15px;color: #606266;margin-left: 5px;">数据加载中</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import flvjs from "../../node_modules/flv.js/src/index"
import Hls from 'hls.js'
import { configs } from '../../static/video/config'
import { getSignUrl } from '@/utils/request.js'
// import videoPargramTransfrom from '@/utils/videoPargramTransfrom.js'
import axios from 'axios'
import qs from 'qs'
// import screenfull from 'screenfull'
export default {
  name: 'hisVideo',
  data() {
    return {
      hisVideolList: [],
      hisVideoLoading: null,
      hisVideoDate: new Date(),
      hisVideoStartEndTime: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0), new Date()],
      isIOS: false,
      isHLS: false,
      moment: moment,
      playAll: false,
      moreIsClick: false,
      routeType: 2,//1 实时 2 历史
      windowHeight: 610,
      videoHeight: 310,
      videoHisHeight: 310,
      touchTime: null,
      searchKey: null,
      searchKeyPre: null,
      showContent: false,
      showContentLoading: false,
      truckSelects: [], // 实际展示的
      truckFilters: [], // 从trucks中根据条件过滤后的总数量
      loadstate: 'more',
      loadContent: {
        contentdown: '点击显示更多',
        contentrefresh: '正在加载...',
        contentnomore: '没有更多数据了'
      },
      pageIndex: 1, // 第一页
      pageSize: 20, // 页大小
      allpage: 0, // 总页数
      truckStateColorEnum: {
        run: 'truckRun',
        stop: 'truckStop',
        offline: 'truckOffline',
        disable: 'truckDisable',
        alarm: 'truckAlarm',
        offpos: 'truckOffpos',
        park: 'truckPark'
      },
      plateNoColorEnum: {
        run: 'plateNoRun',
        stop: 'plateNoStop',
        offline: 'plateNoOffline',
        disable: 'plateNoDisable',
        alarm: 'plateNoAlarm',
        offpos: 'plateNoOffpos',
        park: 'plateNoPark'
      },
      truckStateEnum: {
        run: '行驶',
        stop: '停车',
        offline: '离线',
        disable: '未启用',
        alarm: '报警',
        offpos: '未定位',
        park: '停车',
        s1: '起点',
        s2: '终点'
      },
      seletedAll: false,
      selectChs: [1, 2],
      truckInfo: {
        openid: null,
        userId: null,
        channels: [1, 2, 3, 4, 5, 6, 7, 8], //车的通道
        selectChs: [1, 2], //默认选择的通道
        videoType: 1, //流畅 高清
        truckId: null,
        plateNo: null,
        terminalId: null,
        userType: 1
      },
      windowNum: 0,
      // 窗口数据封装
      liveMapping: [],
      // 播放暂停切换
      playedVideo: true,
      // 播放静音切换
      mutedVideo: true,
      // 窗口时间定时器
      timeid: 0,
      // 播放速率定时器
      timeidspeed: 0,
      // 全屏窗口索引
      fullIndex: null,
      baseUrl: this.$config.CXWAPI,
      urls: [],
      heightChange: 24,
      dbClickVideo: false,
      isFullScreen: '',
      restaurants: [],
      state: '',
      timeout: null
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    document.title = '历史视频-beta'
    this.getDevice()
    this.initVideo()
    this.showDefaultData()
  },
  beforeDestroy() {
    if (this.truckInfo) {
      this.stopAllVideo()
    }
    // 页面销毁时关闭ws。因为有可能ws连接接收数据尚未完成，用户就跳转了页面
    // 在需要主动关闭ws的地方都可以调用该方法
  },
  methods: {
    // 设置一些默认值
    showDefaultData() {
      if (this.hisVideoStartEndTime[1] instanceof Date) {
        this.hisVideoStartEndTime[1] = this.$Util.DateUtil.formatDate(this.hisVideoStartEndTime[1], 'yyyy-MM-dd HH:mm:ss')
      }
    },
    getDevice() {
      if (flvjs.isSupported()) {//只要flv支持 就走flv，不支持 再判断是否是ios
        this.isIOS = false
        this.isHLS = false
      } else {
        this.isIOS = this.getBrowser() === 'Safari'
        this.isHLS = Hls.isSupported() ? true : false //ios 手机端也不支持hls 要用原生
      }
    },
    getBrowser() {
      var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1
      //判断是否Opera浏览器
      if (isOpera) {
        return "Opera"
      }
      //判断是否Firefox浏览器
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      }
      //判断是否chorme浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      }
      //判断是否Safari浏览器
      if (userAgent.indexOf("Safari") > -1 || userAgent.indexOf("iPhone") > -1) {
        return "Safari";
      }
      //判断是否IE浏览器
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
      }
      //判断是否Edge浏览器
      if (userAgent.indexOf("Trident") > -1) {
        return "Edge";
      }
    },
    tipsIos() {
      const that = this
      if (that.getBrowser() === 'Safari') {
        that.$message({
          message: 'IOS系统暂不支持',
          type: 'warning'
        })
      }
    },
    initVideo() {
      const that = this
      //4:3
      that.videoHeight = parseInt(document.body.clientWidth * 3 / 4)
      if (that.$route.params) {
        that.truckInfo = that.$route.params
        that.windowHeight = that.truckInfo.windowHeight
        that.videoHisHeight = that.windowHeight - that.videoHeight - document.getElementsByClassName("videoHeader")[0].clientHeight - 40
        //alert(that.videoHisHeight)
      }
      else {
        that.windowHeight = screen.height
        that.videoHisHeight = that.windowHeight - that.videoHeight - document.getElementsByClassName("videoHeader")[0].clientHeight - 40 - 44 - 55
        that.truckInfo = {
          openid: null,
          userId: null,
          channels: [1, 2, 3, 4, 5, 6, 7, 8], //车的通道
          selectChs: [1, 2], //默认选择的通道
          videoType: 1, //流畅 高清
          truckId: null,
          plateNo: null,
          terminalId: null,
          userType: 1
          // channels: [1, 2, 3, 4, 5, 6, 7, 8],//车的通道
          // selectChs: [1, 2],//默认选择的通道
          // truckId: 3073,
          // plateNo: '粤L7627',
          // terminalId: '40408842916'
        }
      }

      that.selectChs = JSON.parse(JSON.stringify(that.truckInfo)).selectChs
      if (that.truckInfo.plateNo) {
        document.title = '历史视频-beta(' + that.truckInfo.plateNo + ')'
        that.searchKey = that.truckInfo.plateNo
      }
      //这里要做一个 关闭视频判断（切换车辆 关闭上一个 正在播放的通道，需要做缓存 后面实现）
      flvjs.LoggingControl.enableAll = false
      that.liveMapping = []
      that.timeid = 0
      that.timeidspeed = 0
      that.windowNum = 1

      for (let i = 0; i < 1; i++) {
        that.liveMapping[i] = {
          id: i,
          terminalId: that.truckInfo.terminalId,
          channel: that.truckInfo.channels[i],
          plateNo: that.truckInfo.plateNo,
          url: '',
          background: configs.background,
          playing: false,
          playStatus: 'notPlay', // notPlay 未播放 loadding 加载中 playing播放中
          player: null,
          lastCurrentTime: 0,
          objectFit: configs.objectFit,
          muted: false,
          playeState: true,
          muteState: true,
          startTime: null,
          endTime: null,
          replayType: 0,
          multiples: 0,
          videoType: 0
        }
      }
    },
    changeVideo() {
      const that = this
      flvjs.LoggingControl.enableAll = false
      that.liveMapping = []
      // that.timeid = 0
      // that.timeidspeed = 0
      // 查询
      axios.post(getSignUrl('/minapi/device/getDeviceIMEIByTruckId'), qs.stringify({ truckId: that.truckInfo.truckId }),
        {
          headers: {
            'openid': that.truckInfo.openid,
            'userId': that.truckInfo.userId,
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          }
        })
        .then(response => {
          if (response.data.state === 'success' && response.data.result) {
            const device = response.data.result
            const channelStr = device.channelArr
            if (!channelStr) {
              that.truckInfo.channels = [1, 2, 3, 4, 5, 6, 7, 8]
            } else {
              const arr = channelStr.split(',')
              this.truckInfo.channels = []
              arr.forEach((obj) => {
                this.truckInfo.channels.push(parseInt(obj))
              })
            }
            that.truckInfo.terminalId = device.imei
            that.windowNum = 1
            that.truckInfo.selectChs = that.selectChs
            for (let i = 0; i < 1; i++) {
              that.liveMapping[i] = {
                id: i,
                terminalId: that.truckInfo.terminalId,
                channel: that.truckInfo.channels[i],
                plateNo: that.truckInfo.plateNo,
                url: '',
                background: configs.background,
                playing: false,
                playStatus: 'notPlay', // notPlay 未播放 loadding 加载中 playing播放中
                player: null,
                lastCurrentTime: 0,
                objectFit: configs.objectFit,
                muted: false,
                playeState: true,
                muteState: true,
                startTime: null,
                endTime: null,
                replayType: 0,
                multiples: 0,
                videoType: 0
              }
            }

          } else {
            that.$message({
              message: response.data.message,
              type: 'warning'
            })
          }
        })
        .catch(response => {
          that.$message({
            message: '系统异常',
            type: 'warning'
          })
        })
    },
    // 通道号选中事件
    passChange: function(e) {
      this.seletedAll = e.length === this.truckInfo.channels.length
      this.truckInfo.selectChs = e
      this.$Util.ArrayUtil.sort(this.truckInfo.selectChs, 1)
    },
    // 更多通道事件
    morePassClick() {
      this.moreIsClick = !this.moreIsClick
    },
    // 全选事件
    seletedAllCheck() {
      if (!this.seletedAll) {
        this.seletedAll = true
        this.truckInfo.selectChs = this.truckInfo.channels
      } else {
        this.seletedAll = false
        this.truckInfo.selectChs = []
      }
    },
    playRealVideo() {
      this.$router.go(-1) //返回上一层
      // window.history.go(-1)
      //self.location = document.referrer
    },
    /** 车辆搜索界面 加载更多 **/
    loadMoreClick(e) {
      const that = this
      if (that.truckFilters.length <= that.pageSize) {
        // 总页数 小于 页大小 不需要加载
        return
      }
      if (that.pageIndex >= that.allpage) {
        that.loadstate = 'noMore'
        return
      } else {
        that.loadstate = 'loading'
      }
      that.pageIndex++
      setTimeout(() => {
        const arr = that.$Util.ArrayUtil.pagination(that.pageIndex, this.pageSize, that.truckFilters)
        that.truckSelects = that.truckSelects.concat(arr)
        if (that.pageIndex >= that.allpage) {
          that.loadstate = 'noMore'
        } else {
          that.loadstate = 'more'
        }
      }, 1000)
    },
    /* 获取车牌列表*/
    /* 获取车牌列表 输入框 查询 */
    truckSearchInput() {
      const that = this
      if (that.searchKey && that.searchKey.length > 1) {
        if (!that.searchKeyPre || that.searchKey.indexOf(that.searchKeyPre) === -1) {
          that.searchKeyPre = that.searchKey
          that.showSelectContent()
        } else {
          // 历史记录
          that.showContentLoading = true
          that.pageIndex = 1
          that.loadstate = 'more'
          that.truckSelects = []
          setTimeout(() => {
            that.allpage = that.$Util.ArrayUtil.getAllPageNum(that.truckFilters, that.pageSize)
            let tempList = []
            if (!that.searchKey && that.searchKey.length === 0) {
              tempList = that.truckFilters
            } else {
              tempList = that.truckFilters.filter(obj => {
                return obj.plateNo.indexOf(that.searchKey) > -1
              })
            }
            that.truckSelects = that.$Util.ArrayUtil.pagination(that.pageIndex, that.pageSize, tempList)
            that.showContentLoading = false
            if (that.truckSelects.length === 0 || tempList.length <= that.pageSize) {
              that.loadstate = 'noMore'
            }
          }, 500)
        }
      }
    },
    /* 获取车牌列表*/
    /* 获取车牌列表 输入框 查询 */
    showSelectContent() {
      const that = this
      that.truckSelects = []
      that.truckFilters = []
      that.pageIndex = 1
      that.loadstate = 'more'
      that.showContent = true
      that.showContentLoading = true

      setTimeout(() => {
        // 查询
        axios.post(getSignUrl('/minapi/monitor/getTruckStatusList'), qs.stringify({ status: null, plateNo: that.searchKey }),
          {
            headers: {
              'openid': that.truckInfo.openid,
              'userId': that.truckInfo.userId,
              'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
          })
          .then(response => {
            if (response.data.state === 'success') {
              that.truckFilters = response.data.result
              that.allpage = that.$Util.ArrayUtil.getAllPageNum(that.truckFilters, that.pageSize)
              that.truckSelects = that.$Util.ArrayUtil.pagination(that.pageIndex, that.pageSize, that.truckFilters)
              if (that.truckSelects.length === 0) {
                that.loadstate = 'noMore'
              }
            }
            that.showContentLoading = false
          })
          .catch(response => {
            that.showContentLoading = false
          })
      }, 2000);

    },
    /* 获取车牌列表 关闭*/
    truckSearchClose() {
      const that = this
      that.truckSelects = []
      that.truckFilters = []
      that.pageIndex = 1
      that.loadstate = 'more'
      that.searchKey = null
      that.searchKeyPre = null
      that.showContent = false
      that.showContentLoading = false
    },
    /* 车牌列表 选择 */
    truckSearchSelect(data) {
      if (data.state === 'disable') {
        this.$message({
          message: '未启用车辆禁止选择',
          type: 'warning'
        })
        data.select = false
      }
      data.select = !data.select
      this.truckSearchClose()
      if (data.select) {
        // 添加到最近列表
        // this.$store.dispatch('setRecentTruck', {
        //   truckId: data.truckId,
        //   plateNo: data.plateNo
        // })
        this.truckInfo.truckId = data.truckId
        this.truckInfo.plateNo = data.plateNo
        document.title = '历史视频-beta(' + data.plateNo + ')'
        this.stopAllVideo()
        this.searchKey = data.plateNo
        this.playAll = false
        this.changeVideo()
      }
    },
    getDeviceIMEIByTruckId() {
      const that = this
      // 查询
      axios.post(getSignUrl('/minapi/device/getDeviceIMEIByTruckId'), qs.stringify({ truckId: that.truckInfo.truckId }),
        {
          headers: {
            'openid': that.truckInfo.openid,
            'userId': that.truckInfo.userId,
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          }
        })
        .then(response => {
          if (response.data.state === 'success' && response.data.result) {
            const device = response.data.result
            const channelStr = device.channelArr
            that.truckInfo.selectChs = []
            if (!channelStr) {
              that.truckInfo.channels = [1, 2, 3, 4, 5, 6, 7, 8]
            } else {
              that.truckInfo.channels = channelStr.split(',')
            }
            that.truckInfo.terminalId = device.imei
          } else {
            that.$message({
              message: response.data.message,
              type: 'warning'
            })
          }
        })
        .catch(response => {
          that.$message({
            message: '系统异常',
            type: 'warning'
          })
        })

    },
    //查询历史视频
    searcHisVideo() {
      const that = this
      let hisDate = null
      let startTime = null
      let endTime = null
      if (!that.truckInfo.terminalId) {
        that.$message({
          message: '请选择车辆',
          type: 'warning'
        })
        return
      }
      if (!that.hisVideoDate) {
        that.$message({
          message: '请选择日期',
          type: 'warning'
        })
        return
      }
      hisDate = moment(that.hisVideoDate).format('YYYY-MM-DD')
      if (!that.hisVideoStartEndTime) {
        that.$message({
          message: '请选择时间',
          type: 'warning'
        })
        return
      }
      startTime = that.hisVideoStartEndTime[0]
      if (moment(startTime).isValid()) {
        startTime = moment(startTime).format('HH:mm:ss')
      }
      endTime = that.hisVideoStartEndTime[1]
      if (moment(endTime).isValid()) {
        endTime = moment(endTime).format('HH:mm:ss')
      }
      // startTime = moment(hisDate + ' ' + startTime).format('x')
      // endTime = moment(hisDate + ' ' + endTime).format('x')
      startTime = moment(hisDate + ' ' + startTime).format('YYMMDDHHmmss')
      endTime = moment(hisDate + ' ' + endTime).format('YYMMDDHHmmss')
      const terminalId = that.truckInfo.terminalId
      const channel = that.truckInfo.selectChs.length === 1 ? that.truckInfo.selectChs[0] : 0

      that.stopAllVideo()
      that.hisVideolList = []
      that.hisVideoLoading = true
      axios.post(this.baseUrl + '/video/sendQueryItemsReq', qs.stringify({ terminalNo: terminalId, channel: channel, startTime: startTime, endTime: endTime }))
        .then(response => {
          that.hisVideoLoading = false
          if (response.data.res === 1) {
            that.$message({
              message: '查询成功',
              type: 'success'
            })
            if (response.data.obj && response.data.obj.length > 0) {
              that.handleHisVideo(response.data.obj)
            }
          } else {
            that.$message({
              message: response.data.resMsg,
              type: 'warning'
            })
          }
        })
        .catch(response => {
          that.hisVideoLoading = false
          that.$message({
            message: '系统异常',
            type: 'warning'
          })
        })
    },
    handleHisVideo(list) {
      const that = this
      const selectChs = that.truckInfo.selectChs
      list.forEach((obj) => {
        // console.log(moment(this.$Util.DateUtil.parseDate(obj.startTime, 'yyyyMMddHHmmss')).format('YYYY-MM-DD HH:mm:ss'))
        // console.log(moment(this.$Util.DateUtil.parseDate(obj.endTime, 'yyyyMMddHHmmss')).format('YYYY-MM-DD HH:mm:ss'))
        // console.log(moment(this.$Util.DateUtil.parseDate(obj.startTime, 'yyyyMMddHHmmss')).format('HH:mm:ss'))
        // console.log(moment(this.$Util.DateUtil.parseDate(obj.endTime, 'yyyyMMddHHmmss')).format('HH:mm:ss'))
        if (selectChs.includes(obj.logicalChn)) {
          that.hisVideolList.push({
            logicalChn: obj.logicalChn,
            startTime: obj.startTime,
            endTime: obj.endTime,
            fileSize: (obj.fileSize / 1024 / 1024).toFixed(2),
            // resourceType: videoPargramTransfrom.medieaIntToType[obj.resourceType],
            beTime: moment(this.$Util.DateUtil.parseDate('20' + obj.startTime, 'yyyyMMddHHmmss')).format('HH:mm') + '-' + moment(this.$Util.DateUtil.parseDate('20' + obj.endTime, 'yyyyMMddHHmmss')).format('HH:mm')
          })
        }
      })
    },
    playedHisVideo(data) {
      const that = this
      that.stopAllVideo()
      flvjs.LoggingControl.enableAll = false
      that.liveMapping[0].channel = data.logicalChn
      that.liveMapping[0].url = null
      that.liveMapping[0].startTime = data.startTime
      that.liveMapping[0].endTime = data.endTime
      this.playVideo(0, true)
    },
    tick() {
      for (let i = 0; i < this.windowNum; i++) {
        const $video = this.$refs.videoRefs[i]
        if (this.liveMapping[i].playing === false) {
          continue
        }
        if (this.liveMapping[i].pause === true) {
          continue
        }
        const nowTime = this.getms()
        const gapTickTime = nowTime - this.liveMapping[i].tickTime
        if (configs.lostTime * 1000 < gapTickTime) {
          console.log(i, '重新连接：' + this.liveMapping[i].url + ' nowTime ' + nowTime + ' tickTime ' + this.liveMapping[i].tickTime + ' gapTickTime ' + gapTickTime)
          this.replay(i)
        } else {
          console.log(i, '播放进度：' + $video.currentTime)
        }
      }
    },
    speed() {
      for (let i = 0; i < this.windowNum; i++) {
        const $video = this.$refs.videoRefs[i]
        if (this.liveMapping[i].lastCurrentTime !== $video.currentTime) {
          this.liveMapping[i].lastCurrentTime = $video.currentTime
          this.liveMapping[i].tickTime = this.getms()
        }
        if (this.liveMapping[i].playing === false) {
          continue
        }
        if (this.liveMapping[i].pause === true) {
          continue
        }
        let end = 0
        if ($video.buffered.length) {
          end = $video.buffered.end(0)
        }
        if (end <= 0) {
          continue
        }
        const cacheTime = end - $video.currentTime
        if (cacheTime <= 0) {
          continue
        }
        if (this.liveMapping[i].realtime) {
          if (cacheTime < configs.realtime) {
            $video.playbackRate = 1.0
            console.log(i, '播放速度(实时)：' + $video.playbackRate + ' 缓存：' + cacheTime)
          } else {
            $video.playbackRate = 2.0
            console.log(i, '播放速度(实时)：' + $video.playbackRate + ' 缓存：' + cacheTime)
          }
        } else {
          if (cacheTime < configs.smoothtimemax) {
            if (cacheTime < configs.smoothtimemin) {
              $video.playbackRate = 0.8
            } else {
              $video.playbackRate = 1.0
            }
            console.log(i, '播放速度(流畅)：' + $video.playbackRate + ' 缓存：' + cacheTime)
            if (cacheTime < 1) {
              this.liveMapping[i].cache = true
              $video.pause()
            } else {
              if (cacheTime > 2) {
                $video.play()
                this.liveMapping[i].cache = false
              }
            }
          } else {
            $video.playbackRate = 4.0
            console.log(i, '播放速度(流畅)：' + $video.playbackRate + ' 缓存：' + cacheTime)
          }
        }
      }
    },
    retainvideo(r) {
      configs.retainvideo = r
    },
    replay(i) {
      try {
        if (configs.retainvideo) {
          const $video = this.$refs.videoRefs[i]
          if (!this.isIOS) {
            const player = this.liveMapping[i].player
            this.liveMapping[i].tickTime = this.getms()
            player.unload()
            player.load()
            player.play()
            $video.currentTime = 0
            this.liveMapping[i].lastCurrentTime = 0
          }
          else {
            const player = this.liveMapping[i].player
            this.liveMapping[i].tickTime = this.getms()
            if (this.isHLS) {
              player.stopLoad(this.liveMapping[i].url)
              player.loadSource(this.liveMapping[i].url)
              $video.play()
            } else {
              $video.src = null
              $video.pause()
              $video.src = this.liveMapping[i].url
              $video.play()
            }
            $video.currentTime = 0
            this.liveMapping[i].lastCurrentTime = 0
          }
        } else {
          this.stopVideo(i)
          this.playVideo(i, false)
        }
      } catch (exception) {
        console.log(exception)
      }
    },
    // 播放单个视频
    playVideo(i, bLoading) {
      // 未初始化的窗口不让点击播放按钮
      if (this.liveMapping[i].channel === '') {
        return
      }
      if (this.timeid === 0) {
        this.timeid = setInterval(this.tick, configs.lostTime * 1000 * 2)
      }
      if (this.timeidspeed === 0) {
        this.timeidspeed = setInterval(this.speed, 1000)
      }
      try {
        if (this.liveMapping[i].player != null) {
          return
        }
        const plateNo = this.truckInfo.plateNo
        const terminalNo = this.truckInfo.terminalId
        const channel = this.liveMapping[i].channel
        const startTime = this.liveMapping[i].startTime
        const endTime = this.liveMapping[i].endTime
        if (!terminalNo) {
          return
        }
        if (!startTime) {
          return
        }
        if (!endTime) {
          return
        }
        let loading = null
        if (bLoading) {
          loading = this.$loading({
            target: this.$refs.videoOutRefs[i],
            lock: true,
            background: 'rgba(0, 0, 0, 0.7)'
          })
        }
        axios.post(this.baseUrl + '/video/sendPlayBackVideoReq', qs.stringify({ terminalNo: terminalNo, channel: channel, startTime: startTime, endTime: endTime, replayType: 0, multiples: 0, videoType: (this.isIOS ? 4 : 2) })).then((response) => {
          var data = response.data
          if (data.res === 1) {
            try {
              // console.log('plateNo:' + plateNo + ',chennel:' + channel + '-->推流成功url=' + data.obj)
              //alert('plateNo:' + plateNo + ',chennel:' + channel + '-->推流成功url=' + data.obj)
              const $video = this.$refs.videoRefs[i]
              let player = null
              if (!this.isIOS) {
                player = flvjs.createPlayer({ type: 'flv', isLive: true, url: data.obj }, configs.player)
                $video.playbackRate = 1.0
                $video.currentTime = 0
                $video.muted = false
                player.attachMediaElement($video)
                player.load()
                player.play()
              }
              else {
                if (this.isHLS) {
                  player = new Hls()
                  player.loadSource(data.obj)
                  player.attachMedia($video)
                  player.on(Hls.Events.MANIFEST_PARSED, () => {
                    $video.play()
                  })
                }
                else {
                  player = true//就算是不支持hls也赋值一个true
                  if ($video.canPlayType('application/vnd.apple.mpegurl')) {
                    $video.src = data.obj
                    $video.addEventListener('loadedmetadata', function() {
                      $video.play()
                    })
                  }
                }
              }
              const tempMapping = {
                id: i,
                terminalId: terminalNo,
                channel: channel,
                plateNo: plateNo,
                url: data.obj,
                background: configs.background,
                player: player,
                playing: true,
                playStatus: 'playing',
                objectFit: configs.objectFit,
                muted: false,
                playeState: false,
                muteState: true,
                cache: false,
                lastCurrentTime: 0,
                tickTime: this.getms(),
                startTime: startTime,
                endTime: endTime,
                replayType: 0,
                multiples: 0,
                videoType: 0
              }
              this.$set(this.liveMapping, i, tempMapping)
              if (bLoading && loading) {
                setTimeout(() => {
                  loading.close()
                }, 500)
              }
            }
            catch (e) {
              if (bLoading && loading) {
                setTimeout(() => {
                  loading.close()
                }, 500)
              }
            }
          }
          else {
            if (bLoading && loading) {
              loading.close()
            }
            this.$message({
              message: data.resMsg,
              type: 'warning'
            })
          }
        })

      } catch (exception) {
        if (bLoading && loading) {
          loading.close()
        }
        this.$message({
          message: data.resMsg,
          type: '系统异常'
        })
      }
    },
    // state=1表示历史视频停止指令
    // state=2表示历史视频停止指令
    stopVideo(i) {
      try {
        if (this.routeType === 1) {
          this.stopLiveVideoCmd(i)
        } else if (this.routeType === 2) {
          this.stopHisVideoCmd(i)
        }
        const current = this.liveMapping[i]
        if (!current) {
          return
        }
        current.playStatus = 'notPlay'
        const player = this.liveMapping[i].player
        if (!player) {
          return
        }
        const $video = this.$refs.videoRefs[i]
        if (!this.isIOS) {
          player.pause()
          player.unload()
          player.detachMediaElement()
          player.destroy()
          current.player = null
          current.playing = false
          current.playStatus = 'notPlay'
          current.muted = false
          current.playeState = true
          current.muteState = true
          current.cache = false
        }
        else {
          if (this.isHLS) {
            $video.pause()
            current.player.stopLoad()
            current.player.detachMedia()
            current.player.destroy()
          }
          else {
            $video.pause();
            $video.src = null
          }
          current.player = null
          current.playing = false
          current.playStatus = 'notPlay'
          current.muted = false
          current.playeState = true
          current.muteState = true
          current.cache = false
        }
        // 清空视频
        // const video = this.$refs.videoRefs[i]
        // video.setAttribute('poster', '')
      } catch (e) {
        console.log(e)
      }
    },
    // 停止实时播放指令
    stopLiveVideoCmd(i) {
      //console.log('stopVideoCmd:' + i)
      const current = this.liveMapping[i]
      if (current && current.player) {
        const plateNo = current.plateNo
        const terminalId = current.terminalId
        const channel = current.channel
        // 发送停止指令之后 清空车牌和通道
        // current.plateNo = ''
        // current.channel = ''
        axios.post(this.baseUrl + '/video/sendStopRealTimeReq', qs.stringify({ terminalNo: terminalId, channel: channel })).then((response) => {
          if (response.data.res === 1) {
            console.log('plateNo:' + plateNo + ',chennel:' + channel + '-->停止实时播放推流成功')
          } else {
            console.log('plateNo:' + plateNo + ',chennel:' + channel + '-->停止实时播放推流失败')
          }
        })
      }
    },
    // 停止历史播放指令
    stopHisVideoCmd(i) {
      const current = this.liveMapping[i]
      if (current) {
        const plateNo = current.plateNo
        const terminalId = current.terminalId
        const channel = current.channel
        const param = {
          terminalNo: terminalId,
          channel: channel,
          ctrlCmd: 2,
          multiples: 0,
          replayLocation: ''
        }
        axios.post(this.baseUrl + '/video/sendPlayBackControlReq', qs.stringify(param)).then((response) => {
          if (response.data.res === 1) {
            console.log('plateNo:' + plateNo + ',chennel:' + channel + '-->停止历史视频推流成功')
          } else {
            console.log('plateNo:' + plateNo + ',chennel:' + channel + '-->停止历史视频推流失败')
          }
        })
      }
    },
    // 关闭所有视频
    stopAllVideo() {
      // 根据这里的长度解决了一直断线重连的问题
      for (let i = 0; i < this.liveMapping.length; i++) {
        this.stopVideo(i)
      }
    },
    // 静音打开
    voiceOn(i) {
      const current = this.liveMapping[i]
      if (!current || !current.player) {
        return
      }
      const $video = this.$refs.videoRefs[i]
      $video.muted = true
      current.muteState = false
    },
    // 静音关闭
    voiceOff(i) {
      const current = this.liveMapping[i]
      if (!current || !current.player) {
        return
      }
      const $video = this.$refs.videoRefs[i]
      $video.muted = false
      current.muteState = true
    },
    // 截屏
    screenShot(i) {
      const that = this
      const current = this.liveMapping[i]
      if (!current || !current.player) {
        return
      }
      const scale = 1
      const canvas = document.createElement('canvas')
      const video = that.$refs.videoRefs[i]
      canvas.width = video.videoWidth * scale
      canvas.height = video.videoHeight * scale
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
      const img = document.createElement('img')
      img.crossOrigin = 'anonymous'
      img.src = canvas.toDataURL('image/png')
      const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
      this.saveFile(image, current.plateNo + '_' + new Date().getTime() + '.png')
    },
    saveFile(data, filename) {
      var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
      save_link.href = data
      save_link.download = filename
      var event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      save_link.dispatchEvent(event)
    },
    // 全屏缩放
    fullScreen(i) {
      // const element = this.$refs.videoOutRefs[i]
      // screenfull.toggle(element)
      const element = this.$refs.videoOutRefs[i]
      this.$Util.ScreenUtil.elementZoom(element)
      window.zoomMode = 2
    },
    // 双击缩放
    dbFullScreen(i) {
      if (!this.touchTime) {
        this.touchTime = new Date().getTime()
        return
      }
      const nowTouchTime = new Date().getTime()
      if (nowTouchTime - this.touchTime < 500) {
        const element = this.$refs.videoOutRefs[i]
        this.$Util.ScreenUtil.elementZoom(element)
        window.zoomMode = 2
      }
      this.touchTime = null
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    getCurrentImg(i) {
      const that = this
      const current = this.liveMapping[i]
      if (!current || !current.player) {
        return
      }
      const scale = 1
      const canvas = document.createElement('canvas')
      const video = that.$refs.videoRefs[i]
      canvas.width = video.videoWidth * scale
      canvas.height = video.videoHeight * scale
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
      const img = document.createElement('img')
      img.crossOrigin = 'anonymous'
      img.src = canvas.toDataURL('image/png')
      const src = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
      // 设置属性
      video.setAttribute('poster', src)
      // return image
    },
    getms() {
      return new Date().getTime()
    },
    videoSizeChange(i, width, height) {
      const H5VideoDialog = this.$findComponentUtils.findComponentsUpward(this, 'H5VideoDialog')
      if (H5VideoDialog && H5VideoDialog.length > 0) {
        const index = H5VideoDialog[0].isScaleActive
        const $video = this.$refs.videoRefs[i - 1]
        let tempVideoWidth = 0
        if (index === 0) {
          $video.style.width = (width) + 'px'
        } else if (index === 1) {
          tempVideoWidth = ((1.0 * 4 / 3) * (height - this.heightChange))
          if (tempVideoWidth > width) {
            tempVideoWidth = width
          }
          $video.style.width = tempVideoWidth + 'px'
        } else {
          tempVideoWidth = ((1.0 * 16 / 9) * (height - this.heightChange))
          if (tempVideoWidth > width) {
            tempVideoWidth = width
          }
          $video.style.width = tempVideoWidth + 'px'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hisVideo {
  .truckRun {
    background: #a6e5f9;
  }
  .truckOffline {
    background: #d1d1d1;
  }
  .truckStop {
    background: #b5fdbd;
  }
  .truckPark {
    background: #b5fdbd;
  }
  .truckDisable {
    background: #909399;
  }
  .truckOffpos {
    background: #888888;
  }
  .truckAlarm {
    background: #fe3903; //ffacac
  }
  .plateNoRun {
    background: #0365b1;
  }
  .plateNoOffline {
    background: #5d5d5d;
  }
  .plateNoStop {
    background: #3ac53a;
  }
  .plateNoPark {
    background: #3ac53a;
  }
  .plateNoDisable {
    background: #909399;
  }
  .plateNoOffpos {
    background: #888888;
  }
  .plateNoAlarm {
    background: #fe3903; //ffacac
  }
  .treeSelectContent {
    z-index: 9999;
    position: fixed;
    top: 85px;
    width: 100%;
    max-height: 340px;
    background-color: #f1f5f3;
    border-bottom: 2px solid #ababab;
    border-radius: 0px 0px 30px 30px;
    .scroll-y-auto {
      max-height: 300px;
    }
    .truckItem {
      padding: 4px 10px 4px 10px;
      display: flex;
    }
    .truckItem :hover {
      opacity: 0.8;
    }
  }
  .checkboxGroup {
    float: left;
    width: 53vw;
    overflow: hidden;
    position: relative;
    z-index: 999;
    background: #fff;
  }

  .videoContainer {
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    text-align: center;
    width: 100%;
    float: left;
  }
  .videoContainer:nth-child(2n) {
    border-right: none;
  }

  .monitorVideo {
    width: 100%;
    height: calc(100% - 24px);
    background-size: cover;
    object-fit: fill;
    background-image: url(../../static/video/images/bg.png);
  }

  .vehicleInfo {
    width: 100%;
    height: 24px;
    background: rgba(35, 35, 35, 1);
    box-sizing: border-box;
    border-top: 1px solid rgba(48, 48, 48, 1);
    position: absolute;
    bottom: 0px;
    left: 0;
    line-height: 23px;
  }

  .vehiclePass {
    display: inline-block;
    background-color: rgba(176, 176, 176, 0.407843137254902);
    width: 46px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 3px;
    font-size: 12px;
    color: #111111;
    margin: 3px 0px 0px 10px;
    float: left;
  }

  .videoBtn {
    cursor: pointer;
  }

  .playVid {
    position: absolute;
    right: 43px;
    top: 6px;
    width: 12px;
    height: 12px;
    background: url(../../static/video/images/play.png) no-repeat;
    background-size: 12px;
  }

  .pauseVid {
    position: absolute;
    right: 43px;
    top: 6px;
    width: 12px;
    height: 12px;
    background: url(../../static/video/images/stop.png) no-repeat;
    background-size: 12px;
  }

  .disableMute {
    position: absolute;
    right: 24px;
    top: 5px;
    width: 14px;
    height: 14px;
    background: url(../../static/video/images/sound.png) no-repeat;
    background-size: 14px;
  }

  .enableMute {
    position: absolute;
    right: 24px;
    top: 5px;
    width: 14px;
    height: 14px;
    background: url(../../static/video/images/mute.png) no-repeat;
    background-size: 14px;
  }

  .showFull {
    position: absolute;
    right: 5px;
    top: 6px;
    width: 12px;
    height: 12px;
    background: url(../../static/video/images/fullScreen.png) no-repeat;
    background-size: 12px;
  }
}
.hisVideo /deep/ .el-date-editor.el-input {
  width: auto;
}
.hisVideo /deep/ .el-date-editor--timerange.el-input__inner {
  width: auto;
}
.hisVideo /deep/ .el-input--prefix .el-input__inner {
  padding: 0px 24px;
}
.hisVideo /deep/ .el-range-editor.el-input__inner {
  padding: 3px 0px;
}
.hisVideo /deep/ .el-date-editor .el-range__icon {
  margin-left: 0px;
}
.hisVideo /deep/ .el-input__prefix {
  width: 24px;
  left: 0px;
}
.scrollpage {
  width: 100%;
  overflow-y: auto;
  margin-bottom: 10px;
}
.channelNew {
  padding: 0px 0px 0px 15px;
}
.channelItem {
  display: inline-block;
  color: #999;
  border: 1px solid #dcdfe6;
  height: 28px;
  line-height: 28px;
  border-radius: 15px;
  font-size: 12px;
  margin: 10px 15px 0px 0px;
  float: left;
  width: calc(50% - 17px);
}
.videoChannel {
  display: inline-block;
  background: #409eff;
  color: #fff;
  float: left;
  width: 30px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.videoTime {
  display: inline-block;
  // float: left;
  width: 75px;
}
.videoLine {
  width: 1px;
  background: #dcdfe6;
  display: inline-block;
  height: 18px;
  float: left;
  margin-top: 5px;
}
.videoSize {
  display: inline-block;
}
.hisVideo /deep/ .el-input__inner {
  padding-left: 23px;
}
</style>


<style lang="scss" >
/*elementui loading css 覆盖 开始*/
.hisVideo {
  .el-loading-spinner .circular {
    // width: 42px;
    // height: 42px;
    //animation: rotating 2s linear infinite;
    display: none;
  }
  .el-loading-spinner {
    background: url(../../static/video/images/loading.png) no-repeat;
    background-size: 32px 32px;
    position: relative;
    top: 50%;
    left: 45%;
    width: 32px;
    height: 32px;
    animation: rotating 2s linear infinite;
  }
  .el-radio {
    margin-right: 5px;
  }
  .el-checkbox {
    margin-right: 5px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/HisVideo.vue